import FroalaEditor from 'froala-editor';

const NO_CAROUSEL_CLASS = 'fr-no-carousel';

FroalaEditor.RegisterCommand('imageCarouselToggle', {
  title: 'Ungroup',
  icon: 'imageCarouselUngroup',
  undo: true,
  focus: false,
  refreshAfterCallback: true,
  plugin: 'image',
  callback: function (this: FroalaEditor) {
    const $img = this.image.get();
    if (!$img || !$img.length) return;

    if ($img.hasClass(NO_CAROUSEL_CLASS)) {
      $img.removeClass(NO_CAROUSEL_CLASS);
    } else {
      $img.addClass(NO_CAROUSEL_CLASS);
    }

    this.undo.saveStep();
  },
  refresh: function (this: FroalaEditor, $btn) {
    const $img = this.image.get();
    const isUngrouped = $img && $img.hasClass(NO_CAROUSEL_CLASS);
    const iconName = isUngrouped
      ? 'imageCarouselGroup'
      : 'imageCarouselUngroup';

    $btn.attr('title', isUngrouped ? 'Group Image' : 'Ungroup Image');
    $btn
      .find('> *')
      .first()
      .replaceWith((this as any).icon.create(iconName));
  },
});

// Single image = show standalone (ungroup from carousel)
FroalaEditor.DefineIcon('imageCarouselUngroup', {
  NAME: 'image',
  FA5NAME: 'image',
});

// Multiple images = add to carousel (group with others)
FroalaEditor.DefineIcon('imageCarouselGroup', {
  NAME: 'images',
  FA5NAME: 'images',
});
